import { useRef, useState, useEffect } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Icona from 'components/3catinfo/ui/Icona';
import CameraDetallada from 'components/3catinfo/ElTemps/CameraDetallada';
import clsx from 'clsx';
import styles from './modalCamera.module.scss';

const Navegacio = (props) => {
    const { items, index, setIndex } = props;
    const { isMobile } = useViewport();

    const stylesPrevious = clsx({
        [styles.disabled]: index === 0
    });
    const stylesNext = clsx({
        [styles.disabled]: index === items.length - 1
    });

    return (
        <div className={styles.modalNavs}>
            <button
                className={stylesPrevious}
                tabIndex={index === 0 ? -1 : 0}
                onClick={() => {
                    setIndex(index - 1);
                }}
            >
                <Icona className={styles.icona} icona={!isMobile ? 'fletxa_amunt' : 'fletxa_esquerra'} alt='Anterior camera' />
            </button>
            <button
                className={stylesNext}
                tabIndex={index === items.length - 1 ? -1 : 0}
                onClick={() => {
                    setIndex(index + 1);
                }}
            >
                <Icona className={styles.icona} icona={!isMobile ? 'fletxa_avall' : 'fletxa_dreta'} alt='Següent camera' />
            </button>
        </div>
    );
};

const ModalCamera = (props) => {
    const { idSelected = 0, onClickClose } = props;
    let { items } = props;

    const initialFocusRef = useRef(null);
    const [index, setIndex] = useState(idSelected);

    useEffect(() => {
        if (initialFocusRef.current) {
            initialFocusRef.current.focus();
        }
    }, []);

    return (
        <div className={styles.modalMask}>
            <div className={styles.modalWrapper}>
                <div className={styles.modalContent}>
                    <div className={styles.modalContainer}>
                        <CameraDetallada items={items} idSelected={index} onClickClose={onClickClose} mostraLinkTitol={true} />
                    </div>
                </div>
                <Navegacio items={items} index={index} setIndex={setIndex} />
            </div>
        </div >
    );
};

export default ModalCamera;
